export default "__VITE_ASSET__CRt_aofk__"